<template>
  <div class="contract-manage app-panel blank-h blank-v">
    <div class="tabs">
      <p :class="{active: tabsIndex === 1}" @click="switchTab(1)">全部签约客户</p>
      <p :class="{active: tabsIndex === 2}" @click="switchTab(2)">风险签约客户</p>
    </div>
    <contract-all-manage v-if="tabsIndex === 1" ref="contractAllManage"></contract-all-manage>
    <contract-risk-manage v-else ref="contractRiskManage"></contract-risk-manage>
  </div>
</template>

<script>
  import ContractAllManage from '@/views/ContractAllManage.vue';
  import ContractRiskManage from '@/views/ContractRiskManage.vue';

  export default {
    name: 'ContractManage',
    data() {
      return {
        tabsIndex: null
      }
    },
    mounted() {
      this.switchTab(1);
    },
    components: {
      ContractAllManage,
      ContractRiskManage
    },
    methods: {
      switchTab(index) {
        this.tabsIndex = index;
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .contract-manage {
    margin-top: 42px;
    position: relative;
    .tabs {
      display: flex;
      position: absolute;
      top: -42px;
      left: 0;
      p {
        padding: 0 20px;
        cursor: pointer;
        width: 50%;
        height: 40px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 2px solid transparent;
        transition: all @time;
        background-color: rgba(255, 255, 255, .5);
        &.active {
          background-color: rgba(255, 255, 255, 1);
          border-top: 2px solid @color-primary;
        }
      }
    }
  }
</style>